import { useEffect, useState } from 'react';
import { AmenitiesSave, getAmenities } from '../../Services/Service';
import { useParams } from 'react-router-dom';

import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';


const Amenities = () => {
  const { AmenitiesID } = useParams();
  const [amenitiesData, setAmenitiesData] = useState([]);
  const [activeCategory, setActiveCategory] = useState("");
  const [checkedItems, setCheckedItems] = useState({});



  useEffect(() => {
    const fetchAmenities = async () => {
   
      try {
        const result = await getAmenities();
        const parsedJSON = JSON.parse(result[0].AmenitiesJSON);
        setAmenitiesData(parsedJSON);
        setActiveCategory(parsedJSON[0]?.Category || "");
      } catch (error) {
        console.log("error get Amenities", error);
      } 
    };
    fetchAmenities();
  }, []);

  const handleCheckboxChange = (category, itemTitle) => {
    const key = `${category}__${itemTitle}`;
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key]
    }));
  };


  const handleSubmit = async () => {
   
    try {
      const transformedData = amenitiesData.map((category) => ({
        Category: category.Category,
        Item: category.Item.map((item) => ({
          ItemTitle: item.ItemTitle,
          ItemType: item.ItemType || null,
          ItemOption: item.ItemOption || [],
          isItemChecked: !!checkedItems[`${category.Category}__${item.ItemTitle}`],
        })),
      }));

      const response = await AmenitiesSave(transformedData, AmenitiesID);
      console.log('Save Response:', response);
      alert('Amenities saved successfully!');
    } catch (error) {
      console.error('Submit error', error);
      alert('Failed to save amenities.');
    }
  };

  return (
    <>
      

      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />

          <div className="container">
            <div className="page-inner">
              <div className="card ">
                <div className='card-header'>
                  <h4 className='card-title'>Amenities</h4>
                </div>
                <div className='card-body'>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/* Left Side: Category Buttons */}
                      <div className="col-md-3">
                        <div className="d-flex flex-column gap-2">

                          {amenitiesData.map((categoryData, index) => (
                            <button
                              key={index}
                              className={`btn ${activeCategory === categoryData.Category ? 'btn-black' : 'btn-outline-dark'}`}
                              onClick={() => setActiveCategory(categoryData.Category)}
                            >
                              {categoryData.Category}
                            </button>
                          ))}


                        </div>
                      </div>

                      {/* Right Side: Filtered Amenities List */}
                      <div className="col-md-9">
                        {amenitiesData
                          .filter(cat => cat.Category === activeCategory)
                          .map((cat, idx) => (
                            <div key={idx} className="card mb-3">
                              <div className="card-header">
                                <h5 className="card-title mb-0">{cat.Category}</h5>
                              </div>
                              <div className="card-body">
                                {cat.Item.map((item, itemIdx) => (
                                  <div key={itemIdx} className="form-check mb-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`item-${idx}-${itemIdx}`}
                                      checked={!!checkedItems[`${cat.Category}__${item.ItemTitle}`]}
                                      onChange={() => handleCheckboxChange(cat.Category, item.ItemTitle)}
                                      required
                                    />
                                    <label className="form-check-label" htmlFor={`item-${idx}-${itemIdx}`}>
                                      {item.ItemTitle}
                                      {(item.ItemType === 'select' || item.ItemType === 'multiselect') && item.ItemOption?.length > 0 && (
                                        <span className="text-muted"> ({item.ItemOption.join(', ')})</span>
                                      )}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                    <div className="text-end mt-3">
                      <button type="submit" className="btn btn-primary" >Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

        </div>
        
      </div>
    </>
  );
};

export default Amenities;
